export default 
`


╒══════════════════════════════════╕
│ contact_data.hugoxlx             │
╞═══════╤══════════════════════════╡
│ Mail  │ alexander@muehrenberg.de │
├───────┼──────────────────────────┤
│ Phone │ +49 1575 / 66 927 88     │
├───────┼──────────────────────────┤
│ Adr.  │ ********** *             │
│       │ ***** Bremen             │
└───────┴──────────────────────────┘
`